import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.import}import/stockinventorysheet/${COMMON_QUERY_PARAMS.STOCK_ITEM_ID}`;

export interface ImportStockInventorySheetCommandArgs {
  stockInventoryId: string;
  file: File;
}

export async function importStockInventorySheetCommand({
  stockInventoryId,
  file,
}: ImportStockInventorySheetCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    const body = new FormData();

    body.append('File', file);

    return await apiCall<BackResponse<string>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.STOCK_ITEM_ID, stockInventoryId),
      {
        method: SUPPORTED_METHODS.POST,
        body,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
